module.exports = __webpack_public_path__ + "static/media/people-people.b40b6595.png";